import { isEqual, get, sortBy } from "lodash";
import { formSet } from "./utils";

export function createDirtyChecker(
  formId: string,
  inputToItemFn: (input: any) => any,
  compareSections: (initItem: any, currItem: any, initRaw: any, currRaw: any) => Record<string, boolean>,
) {
  return (initial: any, current: any) => {
    formSet(formId, "dirty", {});
    const initItem = inputToItemFn(initial);
    const currItem = inputToItemFn(current);
    const dirtyKeys = compareSections(initItem, currItem, initial, current);
    for (const [key, isDirty] of Object.entries(dirtyKeys)) {
      if (isDirty) {
        formSet(formId, `dirty.${key}`, true);
      }
    }
  };
}

export function compareByPaths(
  mapping: Record<string, { path: string | string[]; unordered?: boolean; sortKey?: string }>,
) {
  return (initItem: any, currItem: any): Record<string, boolean> => {
    const dirty: Record<string, boolean> = {};
    for (const [dirtyKey, config] of Object.entries(mapping)) {
      const paths = Array.isArray(config.path) ? config.path : [config.path];
      for (const path of paths) {
        const initVal = get(initItem, path);
        const currVal = get(currItem, path);
        const isDiff = config.unordered
          ? !isEqualUnordered(initVal, currVal, config.sortKey)
          : !isEqual(initVal, currVal);
        if (isDiff) {
          dirty[dirtyKey] = true;
          break;
        }
      }
    }
    return dirty;
  };
}

function isEqualUnordered(a: any, b: any, sortKey?: string): boolean {
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  if (!Array.isArray(a) || !Array.isArray(b)) return isEqual(a, b);
  if (a.length !== b.length) return false;
  const sortFn = sortKey ? (x: any) => get(x, sortKey) : (x: any) => JSON.stringify(x);
  return isEqual(sortBy(a, sortFn), sortBy(b, sortFn));
}
